// @flow
import styled from "styled-components";
const DefaultContainer = styled.div`
  border-left: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  background-color: white;
  border-radius: 10px;
`;

const DefaultPaddedContainer = styled(DefaultContainer)`
  padding: 20px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12) !important;
`;

const DefaultPaddedContainerNoShadow = styled(DefaultContainer)`
  padding: 20px;
`;

export { DefaultContainer, DefaultPaddedContainer, DefaultPaddedContainerNoShadow };
